import { ConditionInfo } from '../BulkEditModal';
import {
  filterConfig,
  conditionsConfig,
  describeCartValueDiscountBasis,
} from '@app/pages/checkout-app/configs/configs';

export const getConditionKey = (condition: ConditionInfo): string => {
  const parts = [
    condition.name,
    condition.condition,
    condition.values,
    condition.weightUnit || '',
    condition.optionalValue || '',
  ];
  return parts.join('|||');
};

export const parseConditionKey = (key: string): Partial<ConditionInfo> => {
  const [name, condition, values, weightUnit, optionalValue] = key.split('|||');
  return {
    name,
    condition,
    values,
    weightUnit: weightUnit || undefined,
    optionalValue: optionalValue || undefined,
  };
};

export const conditionMatches = (a: ConditionInfo, b: Partial<ConditionInfo>): boolean => {
  if (a.name !== b.name || a.condition !== b.condition || a.values !== b.values) {
    return false;
  }
  if (b.weightUnit && a.weightUnit !== b.weightUnit) {
    return false;
  }
  if (b.optionalValue && a.optionalValue !== b.optionalValue) {
    return false;
  }
  return true;
};

export const getFilterDisplayName = (filterName: string): string => {
  const filter = filterConfig.find((f) => f.value === filterName);
  return filter?.name || filterName;
};

export const getOperatorDisplayName = (operator: string): string => {
  const op = conditionsConfig.find((c) => c.value === operator);
  return op?.name || operator;
};

export const getConditionDisplayText = (condition: ConditionInfo): string => {
  const filterName = getFilterDisplayName(condition.name);
  const operatorName = getOperatorDisplayName(condition.condition);

  let valueDisplay = condition.values;
  let quantity: string | undefined;

  if (valueDisplay && valueDisplay.includes('||')) {
    const parts = valueDisplay.split('||');
    valueDisplay = parts[0];
    quantity = parts[1];
  }

  if (condition.weightUnit) {
    valueDisplay = `${valueDisplay} ${condition.weightUnit}`;
  }

  let result = `${filterName} ${operatorName} ${valueDisplay}`;

  if (condition.name === 'cartValue') {
    return `${result}${describeCartValueDiscountBasis(condition.optionalValue)}`;
  }

  const quantityValue = quantity || condition.optionalValue;
  if (quantityValue) {
    result += `, quantity: ${quantityValue}`;
  }

  return result;
};

export const getOperatorsForFilter = (filterName: string): typeof conditionsConfig => {
  const filter = filterConfig.find((f) => f.value === filterName);
  if (!filter) return [];

  const operatorId = filter.operatorId;
  return conditionsConfig.filter((c) => c.parentId === operatorId);
};

export const getFilterOptions = (): Array<{ value: string; label: string }> => {
  return filterConfig.map((f) => ({
    value: f.value,
    label: f.name,
  }));
};
